import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { FlagIcon } from "react-flag-kit";
import { Divider } from "@material-ui/core";

class Navbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false
        }
    }

    componentDidMount() {
    }

    handleMenu = (event) => {
        this.setState({ isMenuOpen: true, anchorEl: event.currentTarget })
    };

    handleClose = () => {
        this.setState({ isMenuOpen: false })
    };

    render() {

        let { userInfo } = this.props

        return (
            <AppBar color="default" position="fixed" className={"appBar"} >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={this.props.handleDrawerToggle}
                        className="menuButton">
                        <MenuIcon />
                    </IconButton>
                    <div className={"app-Name"} style={{ flexGrow: 2, fontWeight: 'bold' }}>
                        {this.props.title}
                    </div>
                    <div>
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={this.handleMenu}
                            color="inherit"
                        >
                            <Avatar referrerPolicy="no-referrer" src={userInfo ? userInfo.imageUrl : ""} />
                        </IconButton>
                        <Menu
                            style={{ marginTop: 45, marginLeft: 80 }}
                            id="menu-appbar"
                            anchorEl={this.state.anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={this.state.isMenuOpen}

                            onClose={this.handleClose}>
                            <MenuItem disabled><span><b>{this.props.t("first_name")}:</b> {userInfo.firstName}</span></MenuItem>
                            <MenuItem disabled><span><b>{this.props.t("last_name")}:</b> {userInfo.lastName}</span></MenuItem>
                            <MenuItem disabled><span><b>{this.props.t("email")}:</b> {userInfo.email}</span></MenuItem>
                            <MenuItem disabled><span><b>{this.props.t("role")}:</b> {userInfo.role}</span></MenuItem>
                            <Divider />
                            <MenuItem onClick={this.props.logout}><ExitToAppIcon /><span style={{ marginLeft: 15 }}>{this.props.t("logout")}</span></MenuItem>
                        </Menu>
                        <IconButton onClick={() => this.props.i18n.changeLanguage("en")}>
                            <FlagIcon code={"GB"} size={24} />
                        </IconButton>
                        <IconButton onClick={() => this.props.i18n.changeLanguage("hr")}>
                            <FlagIcon code={"HR"} size={24} />
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withRouter(withTranslation()(Navbar));